import React from 'react';
import { FolderPlus, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { InterviewFolder } from '@/hooks/interview/useInterviewFolders';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface FolderAssignMenuProps {
  folders: InterviewFolder[];
  assignedFolderIds: string[];
  onToggleFolder: (folderId: string, isAssigned: boolean) => void;
}

const FolderAssignMenu: React.FC<FolderAssignMenuProps> = ({
  folders,
  assignedFolderIds,
  onToggleFolder,
}) => {
  if (folders.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" title="Legg i mappe">
          <FolderPlus className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {folders.map(folder => {
          const isAssigned = assignedFolderIds.includes(folder.id);
          return (
            <DropdownMenuItem
              key={folder.id}
              onClick={() => onToggleFolder(folder.id, isAssigned)}
            >
              {isAssigned && <Check className="h-4 w-4 mr-2 text-primary" />}
              {!isAssigned && <div className="w-4 mr-2" />}
              {folder.name}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default FolderAssignMenu;
